import { render, staticRenderFns } from "./SalesPlanning.vue?vue&type=template&id=56648696&scoped=true"
import script from "./SalesPlanning.vue?vue&type=script&lang=js"
export * from "./SalesPlanning.vue?vue&type=script&lang=js"
import style0 from "./SalesPlanning.vue?vue&type=style&index=0&id=56648696&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56648696",
  null
  
)

export default component.exports